import { render, staticRenderFns } from "./BloodTestsForm.vue?vue&type=template&id=8468a6ec&"
import script from "./BloodTestsForm.vue?vue&type=script&lang=js&"
export * from "./BloodTestsForm.vue?vue&type=script&lang=js&"
import style0 from "./BloodTestsForm.vue?vue&type=style&index=0&id=8468a6ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports